(function () {
  const OVERLAY = '.hulk-form-modal-custom-overlay';
  const TRIGGER = '[data-hulk-target]';
  const CLOSE = '.hulk-form-modal-custom-close-btn';
  const FOCUSABLE =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let activeOverlay = null;
  let previousFocus = null;

  const hoist = (root, replace) => {
    (root || document).querySelectorAll(OVERLAY).forEach((overlay) => {
      if (overlay.parentElement === document.body) return;

      const existing = overlay.id
        ? Array.prototype.find.call(
            document.body.children,
            (el) => el.id === overlay.id && el !== overlay
          )
        : null;

      if (existing) {
        if (!replace) {
          overlay.remove();
          return;
        }
        existing.remove();
      }

      const section = overlay.closest('.shopify-section');
      if (section && section.id) overlay.dataset.hulkSection = section.id;

      document.body.appendChild(overlay);
    });
  };

  const closeModal = (overlay) => {
    if (!overlay) return;
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    if (activeOverlay === overlay) activeOverlay = null;
    if (!document.querySelector(OVERLAY + '.active')) document.body.classList.remove('no-scroll');
    if (previousFocus && document.contains(previousFocus)) previousFocus.focus();
    previousFocus = null;
  };

  const openModal = (overlay, trigger) => {
    if (!overlay) return;
    if (activeOverlay && activeOverlay !== overlay) closeModal(activeOverlay);
    previousFocus = trigger;
    activeOverlay = overlay;
    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const closeBtn = overlay.querySelector(CLOSE);
    if (closeBtn) closeBtn.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER);
    if (trigger) {
      const overlay = document.querySelector(trigger.getAttribute('data-hulk-target'));
      if (overlay) {
        event.preventDefault();
        openModal(overlay, trigger);
      }
      return;
    }

    if (event.target.closest(CLOSE)) {
      closeModal(event.target.closest(OVERLAY));
      return;
    }

    if (event.target.matches(OVERLAY)) closeModal(event.target);
  });

  document.addEventListener('keydown', (event) => {
    if (!activeOverlay) return;

    if (event.key === 'Escape') {
      closeModal(activeOverlay);
      return;
    }

    if (event.key !== 'Tab') return;

    const items = Array.prototype.filter.call(
      activeOverlay.querySelectorAll(FOCUSABLE),
      (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length
    );
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', (event) => hoist(event.target, true));

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.id) return;
    const selector = OVERLAY + '[data-hulk-section="' + event.target.id + '"]';
    document.querySelectorAll(selector).forEach((overlay) => {
      if (document.querySelector(TRIGGER + '[data-hulk-target="#' + overlay.id + '"]')) return;
      if (overlay === activeOverlay) closeModal(overlay);
      overlay.remove();
    });
  });

  hoist();
})();
